<template>
  <b-modal @close="close" :active.sync="isTransactionModalActive" :width="640" scroll="keep">
    <form>
      <div class="modal-card" style="width: auto;">
        <header class="modal-card-head">
          <p v-if="isEdit" class="modal-card-title">
            {{ $t("transactionModal.titleModalEdit") }}
          </p>
          <p v-else class="modal-card-title">
            {{ $t("transactionModal.titleModalAdd") }}
          </p>
        </header>
        <section class="modal-card-body">
          <!-- TODO setting date to something differnt than currenMonth = Sea of trouble -->
          <date-picker
            v-model="transaction.date"
            :label="$t('form.selectMonth')"
          ></date-picker>

          <b-field :label="$t('transaction.name')">
            <b-input
              type="text"
              v-model="transaction.name"
              :placeholder="$t('transaction.name')"
              required
            >
            </b-input>
          </b-field>

          <b-field :label="$t('transaction.category')">
            <b-autocomplete
              v-model="transaction.category"
              ref="autocomplete"
              :data="filteredCategories"
              :placeholder="$t('transaction.category')"
              :open-on-focus="true"
              @select="(category) => (transaction.category = category)"
            >
            </b-autocomplete>
          </b-field>

          <b-field :label="$t('transaction.amount')">
            <b-input
              type="number"
              v-model="transaction.amount"
              :placeholder="$t('transaction.amount')"
              required
            >
            </b-input>
          </b-field>

          <b-field :label="$t('form.incomeExpense')">
            <b-switch
              v-model="transaction.type"
              true-value="income"
              false-value="expense"
            >
              {{ transaction.type }}
            </b-switch>
          </b-field>
        </section> 
        <footer class="modal-card-foot" :class="'multiple'">
          <b-button
            v-if="isEdit"
            class="button is-danger"
            @click="deleteTransaction"
            >{{ $t("button.delete") }}</b-button
          >
          <b-button
            class="button is-primary"
            @click="validateBeforeAddTransaction"
            v-if="!isEdit"
            >{{ $t("button.add") }}</b-button
          >
          <b-button
            class="button is-primary"
            @click="validateBeforeEditTransaction"
            v-if="isEdit"
            >{{ $t("button.edit") }}</b-button
          >
        </footer>
      </div>
    </form>
  </b-modal>
</template>

<script>
const defaultTransaction = {
  date: new Date(),
  name: "",
  category: "",
  amount: 0,
  type: "expense"
};

import firebase from "firebase/app";
import DatePicker from "@/components/DatePicker.vue";
import toast from "@/mixins/toast";
import { mapGetters } from "vuex";

export default {
  mixins: [toast],
  components: {
    DatePicker
  },
  name: "TransactionModal",
  props: {
    isTransactionModalActive: {
      type: Boolean
    },
    transactionToEdit: {
      type: Object
    }
  },
  data() {
    return {
      transaction: { ...defaultTransaction },
      originalTransaction: {}
    };
  },
  methods: {
    addCategory() {
      let categoryToAdd = { name: this.transaction.category };
      this.$store.dispatch("categories/addCategory", {
        categoryToAdd,
        type: this.transaction.type
      });
    },
    validTransaction() {
      return (
        this.transaction.date &&
        this.transaction.name &&
        this.transaction.category &&
        this.transaction.amount >= 0
      );
    },
    validateBeforeEditTransaction() {
      if (this.validTransaction()) {
        this.editTransaction();
      } else {
        this.showInvalidFormMessage();
      }
    },
    validateBeforeAddTransaction() {
      if (this.validTransaction()) {
        this.addTransaction();
      } else {
        this.showInvalidFormMessage();
      }
    },
    checkAddCategory() {
      if (this.filteredCategories.length === 0) {
        this.addCategory();
      }
    },
    editTransaction() {
      this.checkAddCategory();

      this.$store
        .dispatch("transactions/editTransaction", {
          transactionToEdit: this.transaction,
          originalTransaction: this.originalTransaction
        })
        .then(this.showValidTransactionEdit);
      this.close();
    },
    addTransaction() {
      this.checkAddCategory();

      this.$store
        .dispatch("transactions/addTransaction", this.transaction)
        .then(this.showValidTransactionAdded);
      this.transaction = { ...defaultTransaction };
      this.close();
    },
    deleteTransaction() {
      this.$store
        .dispatch("transactions/deleteTransaction", this.transaction)
        .then(this.showValidTransactionDeleted);
      this.transaction = { ...defaultTransaction };
      this.close();
    },
    close() {
      this.$emit("close");
    },
    showValidTransactionAdded() {
      this.showSuccessToast("Transaction added");
    },
    showValidTransactionDeleted() {
      this.showSuccessToast("Transaction deleted");
    },
    showValidTransactionEdit() {
      this.showSuccessToast("Transaction editted");
    },
    showInvalidFormMessage() {
      this.showErrorToast("Please fill in all the fields.");
    },
    showValidCategoryAdded() {
      this.showErrorToast("Category added");
    },
    showInvalidCategoryAdded() {
      this.showErrorToast("Could not add category");
    }
  },
  computed: {
    ...mapGetters("categories", ["categoriesIncome", "categoriesExpense"]),
    isEdit() {
      return this.transactionToEdit ? true : false;
    },
    categoriesIncomeOrExpense() {
      if (this.transaction.type === "income") {
        return this.categoriesIncome;
      } else {
        return this.categoriesExpense;
      }
    },
    filteredCategories() {
      return this.categoriesIncomeOrExpense
        .map((option) => option.name)
        .filter((option) => {
          this.transaction.category = this.transaction.category
            ? this.transaction.category
            : "";
          return (
            option
              .toString()
              .toLowerCase()
              .indexOf(this.transaction.category.toLowerCase()) >= 0
          );
        });
    },
    monthNames() {
      return [
        this.$t("date.january"),
        this.$t("date.february"),
        this.$t("date.march"),
        this.$t("date.april"),
        this.$t("date.may"),
        this.$t("date.june"),
        this.$t("date.july"),
        this.$t("date.august"),
        this.$t("date.september"),
        this.$t("date.october"),
        this.$t("date.november"),
        this.$t("date.december")
      ];
    }
  },
  watch: {
    transactionToEdit(value) {
      this.originalTransaction = { ...value };
      this.transaction = { ...value };
      this.transaction.date = new Date(value.date.seconds * 1000);
    }
  }
};
</script>
